import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { closeStaffModal } from "../../redux/features/staffModalSlice";
import { AddKyc, getKycDetail } from "../../redux/services/kycService/kyc.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { getAdminData } from "../../Utils/role";
function FileInput({
    label,
    name,
    required = false,
    accept = ".jpg,.jpeg,.png,.pdf",
    errors,
    formData,
    handleFileChange,
    existingImage,
}) {
    return (
        <div className="col-md-6">
            <label className="form-label">
                {label} {required && <span className="text-light">*</span>}
            </label>
            <input
                type="file"
                name={name}
                accept={accept}
                onChange={handleFileChange}
                className={`form-control custumform ${errors?.[name] ? "is-invalid" : ""}`}
            />
            {errors?.[name] && (
                <div className="invalid-feedback d-block">
                    {Array.isArray(errors[name]) ? errors[name][0] : errors[name]}
                </div>
            )}

            {/* ✅ naya preview ya existing image show karo */}
            {(formData[name + "_preview"] || existingImage) && (
                <div className="mt-2">
                    <img
                        src={formData[name + "_preview"] || existingImage}
                        alt={label}
                        style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                        }}
                    />
                </div>
            )}
        </div>
    );
}

function AddVendorKyc({ data, isModal = false }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(false); // ✅ GET ke liye loading
    const [errors, setErrors] = useState({});
    const [existingKyc, setExistingKyc] = useState(null); // ✅ GET se aaya data
    const adminData = getAdminData();
    const vendorId = adminData.id;

    const [formData, setFormData] = useState({
        name: data?.name || "",
        email: data?.email || "",
        mobile: data?.mobile || "",
        aadhaar_number: data?.aadhaar_number || data?.adhar_number || "",
        pan_number: data?.pan_number || "",
        address: data?.address || "",
        aadhaar_front: null,
        aadhaar_back: null,
        pan_card_image: null,
    });

    // ✅ GET KYC DETAIL API CALL
    useEffect(() => {
        const fetchKycDetail = async () => {
            try {
                setFetching(true);
                const res = await getKycDetail(vendorId);
                   const kyc = res?.data?.kyc || res?.kyc || res?.data || res;
                if (kyc) {
                    setExistingKyc(kyc);
                    setFormData((prev) => ({
                        ...prev,
                        name: kyc?.name || prev.name,
                        email: kyc?.email || prev.email,
                        mobile: kyc?.mobile || prev.mobile,
                        aadhaar_number:
                            kyc?.aadhaar_number || kyc?.adhar_number || prev.aadhaar_number,
                        pan_number: kyc?.pan_number || prev.pan_number,
                        address: kyc?.address || prev.address,
                        // files null hi rahengi, existing images alag se show hongi
                    }));
                }
            } catch (error) {
                console.log("KYC detail fetch error:", error);
                const response = error?.response?.data;
                errorToast(
                    response?.message || response?.errors || "Failed to load KYC details"
                );
            } finally {
                setFetching(false);
            }
        };

        fetchKycDetail();
    }, [data?.id]);

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === "aadhaar_number") {
            value = value.replace(/\D/g, "");
        }
        if (name === "pan_number") {
            value = value.toUpperCase();
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: null,
            }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files?.[0] || null;

        if (formData[name + "_preview"]) {
            URL.revokeObjectURL(formData[name + "_preview"]);
        }

        let previewUrl = null;
        if (file && file.type.startsWith("image/")) {
            previewUrl = URL.createObjectURL(file);
        }

        setFormData((prev) => ({
            ...prev,
            [name]: file,
            [name + "_preview"]: previewUrl,
        }));
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: null,
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) newErrors.name = ["Vendor name is required"];
        if (!formData.email.trim()) newErrors.email = ["Email is required"];
        if (!formData.mobile.trim()) {
            newErrors.mobile = ["Mobile is required"];
        } else if (!/^\d{10}$/.test(formData.mobile)) {
            newErrors.mobile = ["Enter a valid 10-digit mobile number"];
        }

        if (!formData.aadhaar_number || !/^\d{12}$/.test(formData.aadhaar_number)) {
            newErrors.aadhaar_number = ["Enter a valid 12-digit Aadhaar number"];
        }

        if (!formData.pan_number || !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.pan_number)) {
            newErrors.pan_number = ["Enter a valid PAN (e.g. ABCDE1234F)"];
        }

        if (!formData.address.trim()) newErrors.address = ["Address is required"];

        // ✅ Agar existing image hai to file required nahi
        if (!formData.aadhaar_front && !existingKyc?.aadhaar_front) {
            newErrors.aadhaar_front = ["Aadhaar front is required"];
        }
        if (!formData.aadhaar_back && !existingKyc?.aadhaar_back) {
            newErrors.aadhaar_back = ["Aadhaar back is required"];
        }
        if (!formData.pan_card_image && !existingKyc?.pan_card_image) {
            newErrors.pan_card_image = ["PAN card is required"];
        }

        setErrors(newErrors);
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setTimeout(() => {
                const firstErrorField = document.querySelector(".is-invalid");
                if (firstErrorField) {
                    firstErrorField.focus();
                    firstErrorField.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }, 100);
            return;
        }

        try {
            setLoading(true);

            const submitData = new FormData();

            if (data?.id) submitData.append("vendor_id", data.id);
            submitData.append("name", formData.name);
            submitData.append("email", formData.email);
            submitData.append("mobile", formData.mobile);
            submitData.append("address", formData.address);
            submitData.append("aadhaar_number", formData.aadhaar_number);
            submitData.append("adhar_number", formData.aadhaar_number);
            submitData.append("pan_number", formData.pan_number);

            if (formData.aadhaar_front) submitData.append("aadhaar_front", formData.aadhaar_front);
            if (formData.aadhaar_back) submitData.append("aadhaar_back", formData.aadhaar_back);
            if (formData.pan_card_image) submitData.append("pan_card_image", formData.pan_card_image);

            const res = await AddKyc(submitData);

            if (res?.status === true) {
                successToast(res?.message || "Vendor KYC submitted successfully");
                if (isModal) dispatch(closeStaffModal());
                else navigate(-1);
            } else {
                if (res?.message && typeof res.message === "object") {
                    setErrors(res.message);
                } else {
                    errorToast(res?.message || res?.errors || "Something went wrong");
                }
            }
        } catch (error) {
            console.log("KYC submit error:", error);
            const response = error?.response?.data;
            if (response?.message && typeof response.message === "object") {
                setErrors(response.message);
            } else {
                errorToast(response?.errors || response?.message || "Failed to submit KYC");
            }
        } finally {
            setLoading(false);
        }
    };

    // ✅ GET loading state
    if (fetching) {
        return (
            <div className="main_page">
                <div className="card">
                    <div className="card-body text-center py-5">
                        <div className="spinner-border text-primary" role="status" />
                        <p className="mt-3 mb-0">Loading KYC details...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="main_page">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="mb-0">Complete Your KYC</h4>
                        <button type="button" className="add-btn" onClick={() => navigate(-1)}>
                            Back
                        </button>
                    </div>
                    <form onSubmit={handleSubmit} className="row g-3">
                        <div className="col-md-6">
                            <label>Name <span className="text-light">*</span></label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.name ? "is-invalid" : ""}`}
                                placeholder="Enter name"
                            />
                            {errors?.name && (
                                <div className="invalid-feedback d-block">{errors.name[0]}</div>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label>Email <span className="text-light">*</span></label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.email ? "is-invalid" : ""}`}
                                placeholder="Enter email"
                            />
                            {errors?.email && (
                                <div className="invalid-feedback d-block">{errors.email[0]}</div>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label>Mobile <span className="text-light">*</span></label>
                            <input
                                type="text"
                                name="mobile"
                                value={formData.mobile}
                                maxLength={10}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setFormData((prev) => ({ ...prev, mobile: value }));
                                    if (errors.mobile) setErrors((prev) => ({ ...prev, mobile: null }));
                                }}
                                className={`form-control custumform ${errors?.mobile ? "is-invalid" : ""}`}
                                placeholder="Enter mobile number"
                            />
                            {errors?.mobile && (
                                <div className="invalid-feedback d-block">{errors.mobile[0]}</div>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label className="form-label">
                                Aadhaar Number <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control custumform ${errors.aadhaar_number ? "is-invalid" : ""}`}
                                name="aadhaar_number"
                                value={formData.aadhaar_number}
                                onChange={handleChange}
                                placeholder="123456789012"
                                maxLength={12}
                                inputMode="numeric"
                            />
                            {errors.aadhaar_number && (
                                <div className="invalid-feedback d-block">{errors.aadhaar_number[0]}</div>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label className="form-label">
                                PAN Number <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control custumform ${errors.pan_number ? "is-invalid" : ""}`}
                                name="pan_number"
                                value={formData.pan_number}
                                onChange={handleChange}
                                placeholder="ABCDE1234F"
                                maxLength={10}
                                style={{ textTransform: "uppercase" }}
                            />
                            {errors.pan_number && (
                                <div className="invalid-feedback d-block">{errors.pan_number[0]}</div>
                            )}
                        </div>

                        <div className="col-md-12">
                            <label>Address <span className="text-light">*</span></label>
                            <textarea
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                rows="3"
                                className={`form-control custumform ${errors?.address ? "is-invalid" : ""}`}
                                placeholder="Enter address"
                            />
                            {errors?.address && (
                                <div className="invalid-feedback d-block">{errors.address[0]}</div>
                            )}
                        </div>

                        <div className="col-12 mt-4">
                            <h5 className="mb-3">KYC Documents</h5>
                        </div>

                        {/* ✅ existingImage pass karo GET se aayi image */}
                        <FileInput
                            label="Aadhaar Card Front"
                            name="aadhaar_front"
                            errors={errors}
                            formData={formData}
                            handleFileChange={handleFileChange}
                            existingImage={existingKyc?.aadhaar_front}
                        />
                        <FileInput
                            label="Aadhaar Card Back"
                            name="aadhaar_back"
                            errors={errors}
                            formData={formData}
                            handleFileChange={handleFileChange}
                            existingImage={existingKyc?.aadhaar_back}
                        />
                        <FileInput
                            label="PAN Card"
                            name="pan_card_image"
                            errors={errors}
                            formData={formData}
                            handleFileChange={handleFileChange}
                            existingImage={existingKyc?.pan_card_image}
                        />

                        <div className="col-12 text-end mt-4">
                            <button type="submit" className="add-btn" disabled={loading}>
                                {loading ? "Submitting..." : "Submit KYC"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddVendorKyc;